import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'; // Importamos Routes y Route
import './App.css';
import Header from './components/Header/Header';
import CustomNav from './components/Nav/Nav';
import HeroSection from './components/HeroSection/HeroSection';
import FeaturesSection from './components/FeaturesSection/FeaturesSection';
import TestimonialsSection from './components/TestimonialsSection/TestimonialsSection';
import PlanSection from './components/PlanSection/PlanSection';
import Footer from './components/Footer/Footer';
import AboutSection from './components/AboutSection/AboutSection'; // Importamos la sección "Acerca de"

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <CustomNav />
        <main>
          <Routes>
            {/* Ruta principal con la sección Hero */}
            <Route path="/" element={
              <>
                <HeroSection />
                <FeaturesSection />
                <TestimonialsSection />
                <PlanSection />
              </>
            } />
            
            {/* Ruta para la sección "Acerca de" */}
            <Route path="/about" element={<AboutSection />} />

            {/* Puedes añadir más rutas para otras páginas si es necesario */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
